import { IPendingDhsSsaRepository } from '../ports/outbound/IPendingDhsSsaRepository';
import { PendingDhsSsaResult } from '../domain/entities/PendingDhsSsaResult';

export class FetchPendingDhsSsaUseCase {
  constructor(private repository: IPendingDhsSsaRepository) {}

  async execute(): Promise<PendingDhsSsaResult> {
    return this.repository.fetchPendingDhsSsaCases();
  }
}
